if (document.querySelector(".c-accordions-image-swap")) {
  document.querySelectorAll(".c-accordions-image-swap").forEach((container) => {
    if (container.querySelector(".c-accordions-image-swap__item.open")) {
      const openAccordion = container.querySelector(
        ".c-accordions-image-swap__item.open .c-accordions-image-swap__item-content"
      );
      openAccordion.style.setProperty(
        "--text-height",
        openAccordion.scrollHeight + "px"
      );
    }

    let prevAccordionImg = container.querySelector(
      ".c-accordions-image-swap__item-image.show"
    ); // Track the previously shown image for this container

    container.addEventListener("click", (event) => {
      const clickedAccordion = event.target.closest(
        ".c-accordions-image-swap__item"
      );
      if (!clickedAccordion) return; // Only proceed if an accordion item was clicked

      handleAccordionClick(container, clickedAccordion);

      // Remove accordion image swap on click
      clearInterval(autoSwapInterval);
    });

    let autoSwapInterval; // Declare the variable outside of the observer callback

    const observerOptions = {
      root: null, // Default to the viewport
      rootMargin: "-25% 0px 0px 0px", // Trigger when the top of the container is 25% into the viewport
      threshold: 0.3, // Trigger when any part of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!autoSwapInterval) {
            const delay = container.getAttribute("data-delay");

            autoSwapInterval = setInterval(() => {
              let currentAccordion = container.querySelector(
                ".c-accordions-image-swap__item.open"
              ); // Start with the first accordion
              let nextAccordion = currentAccordion.nextElementSibling; // Get the next sibling

              // If no next sibling, loop back to the first one
              if (!nextAccordion) {
                nextAccordion = container.querySelector(
                  ".c-accordions-image-swap__item"
                ); // Start from the top
              }

              handleAccordionClick(container, nextAccordion); // Simulate a click on the next accordion
            }, delay);
          }
        } else {
          // Clear the interval when the element is not intersecting
          if (autoSwapInterval) {
            clearInterval(autoSwapInterval);
            autoSwapInterval = null; // Reset the interval variable
          }
        }
      });
    }, observerOptions);

    // Observe the container for visibility
    if (container.classList.contains("auto-image-swap")) {
      observer.observe(container);
    }

    // Function to handle the accordion click and image swap
    function handleAccordionClick(container, clickedAccordion) {
      const accordions = container.querySelectorAll(
        ".c-accordions-image-swap__item"
      );
      accordions.forEach((accordion) => {
        if (accordion === clickedAccordion) {
          // Toggle 'open' class only on the clicked accordion
          accordion.classList.toggle("open");
          const accordionContent = accordion.querySelector(
            ".c-accordions-image-swap__item-content"
          );
          if (accordion.classList.contains("open")) {
            accordionContent.style.setProperty(
              "--text-height",
              accordionContent.scrollHeight + "px"
            );
          } else {
            accordionContent.style.setProperty("--text-height", "0px");
          }
        } else {
          // Ensure all other accordions in the container are closed
          accordion.classList.remove("open");
          const accordionContent = accordion.querySelector(
            ".c-accordions-image-swap__item-content"
          );
          accordionContent.style.setProperty("--text-height", "0px");
        }
      });

      // Handle image visibility for clicked accordion
      const accordionImg = container.querySelector(
        `.c-accordions-image-swap__item-image.image-${clickedAccordion.getAttribute(
          "data-item"
        )}`
      );
      if (prevAccordionImg) {
        prevAccordionImg.classList.remove("show");
      }
      accordionImg.classList.add("show");
      prevAccordionImg = accordionImg; // Update the previously shown image reference
    }
  });
}
